<template>
  <v-container :class="containerClass" fluid>
    <subscription-package-form mode="add" @cancel="onCancel">
      <template #header>
        <div class="d-flex align-center">
          <v-btn
            icon
            color="primary"
            class="mr-2"
            :href="$route('subscription-packages.index')"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <h2>Create new subscription package</h2>
        </div>
      </template>
    </subscription-package-form>
  </v-container>
</template>
<script>
import LayoutDashboard from '@layouts/Dashboard'
import SubscriptionPackageForm from '@components/SubscriptionPackage/Form'
export default {
  components: {
    SubscriptionPackageForm,
  },
  layout: LayoutDashboard,
  methods: {
    onCancel() {
      window.location.href = this.$route('subscription-packages.index')
    },
  },
}
</script>
